/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarAdminController', EjemplarAdminController);

    /* @ngInject */
    function EjemplarAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                       ModalService, Ejemplar, Principal) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Ejemplar;

        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            id: $stateParams.edicionId,
            revisado: undefined,
            publicado: undefined
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {signatura: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Ejemplar.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.ejemplar.delete.name',
                                body: 'admin.ejemplar.delete.confirm',
                                property: 'signatura'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        }

    }

})(angular);
